// src/components/BlogFeed.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';

const BlogFeed = ({ isDietitianView = false }) => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    // NEW STATE: Tracks the ID of the blog post currently showing full content
    const [expandedBlogId, setExpandedBlogId] = useState(null); 

    useEffect(() => {
        let q = query(
            collection(db, 'blogs'),
            orderBy('createdAt', 'desc') 
        );

        if (!isDietitianView) {
            q = query(q, where('status', '==', 'published'));
        }

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedBlogs = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                date: doc.data().createdAt ? doc.data().createdAt.toDate() : new Date(),
            }));
            setBlogs(fetchedBlogs);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching blogs:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [isDietitianView]);

    // NEW FUNCTION: Toggles the expanded view for a specific blog ID
    const toggleReadMore = (id) => {
        setExpandedBlogId(id === expandedBlogId ? null : id);
    };

    if (loading) return <p>Loading blogs...</p>;
    
    return (
        <div className="blog-feed"> 
            {blogs.length === 0 && <p>No blog posts found.</p>}
            
            {blogs.map(blog => {
                // Determine if this specific blog post should be expanded
                const isExpanded = blog.id === expandedBlogId;

                return (
                    <div key={blog.id} className="blog-post-card"> 
                        <h3>{blog.title} 
                            {isDietitianView && blog.status === 'draft' && <span className="status-tag draft-tag">(DRAFT)</span>}
                        </h3>
                        <p>By {blog.authorName} on {blog.date.toLocaleDateString()}</p>
                        
                        {/* CONDITIONAL CONTENT DISPLAY */}
                        {!isExpanded && (
                            // Show snippet if NOT expanded
                            <p>{blog.content.substring(0, 300)}...</p> 
                        )}
                        
                        {isExpanded && (
                            // Show full content if expanded
                            <p>{blog.content}</p> 
                        )}

                        {/* BUTTON WITH FUNCTIONALITY */}
                        <button 
                            className="btn btn-read-more"
                            onClick={() => toggleReadMore(blog.id)}
                        >
                            {isExpanded ? 'Show Less' : 'Read More'}
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default BlogFeed;